module.exports = __webpack_public_path__ + "img/card5.b848f883.png";